import React from "react";
import { Button, Modal } from "react-bootstrap";

class DeleteConfirmPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    //props received
    /*
		//variable
		confirmMessage		custom message
		open			flag to show/hide modal
		records			list of IDs to be deleted

		//events
    toggleDeletePopup			onshow/onhide action
    deleteAction          on confirm call this with records
		*/

    this.toggleDeletePopup = this.toggleDeletePopup.bind(this);
  }

  toggleDeletePopup(e, is_delete = false) {
    if (is_delete) {
      this.props.deleteAction(this.props.records);
    }

    this.props.toggleDeletePopup();
  }

  render() {
    return (
      <React.Fragment>
        <Modal show={this.props.open} onHide={this.toggleDeletePopup} size="md">
          <Modal.Header>
            <Modal.Title>
              <i className="feather-alert-triangle mb-3 mr-2" />
              {this.props.confirmMessage || "Are you sure want to delete?"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            <Button
              className="btn-secondary"
              onClick={e => this.toggleDeletePopup(e, true)}
            >
              Yes
            </Button>
            <Button
              className="btn-light"
              onClick={e => this.toggleDeletePopup(e, false)}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default DeleteConfirmPopup;
